import { createActions } from 'redux-actions';

export const { updateGuestServices } = createActions('UPDATE_GUEST_SERVICES');
